<script>
  import { imgSrc } from '$client';
  export let data;
</script>

<section itemscope itemtype="https://schema.org/HowToSection" class="container steps">
  <h2 itemprop="name">{data.header}</h2>
  <ol>
    {#each data.data as step, index}
      <li class="step" itemprop="itemListElement" itemscope itemtype="https://schema.org/HowToStep">
        <meta itemprop="position" content={index + 1} />
        <div itemprop="afterMedia" itemscope itemtype="https://schema.org/ImageObject">
          <img
            loading="lazy"
            itemprop="contentUrl"
            height={step.img.data.attributes.height}
            width={step.img.data.attributes.width}
            src={imgSrc(step.img.data.attributes.url)}
            alt={step.img.data.attributes.alternativeText} />
        </div>
        <p itemprop="text">{step.header}</p>
      </li>
    {/each}
  </ol>
</section>

<style lang="scss">
  section {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }

  h2,
  p {
    font-family:
      Vela Sans,
      sans-serif;
  }

  h2 {
    font-weight: 800;
    font-size: 32px;

    @media only screen and (max-width: 767.98px) {
      font-size: 25px;
    }
  }

  ol {
    display: inline-flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 50px;
    overflow-y: hidden;

    li {
      position: relative;
      display: flex;
      flex-direction: column;
      gap: 15px;
      align-items: flex-start;
      min-width: 210px;
      margin-left: 30px;

      @media only screen and (max-width: 991.98px) {
        min-width: 164px;
      }

      &::before {
        position: absolute;
        top: 20%;
        left: -100px;
        width: 75px;
        height: 25px;
        background-image: url('https://admin.uberi.pro/uploads/arrow_b33a7b9982.svg');
        background-repeat: no-repeat;
        content: '';

        @media only screen and (max-width: 991.98px) {
          left: -100px;
        }

        @media only screen and (max-width: 767.98px) {
          left: -90px;
        }
      }

      p {
        font-weight: 600;
        font-size: 16px;
        line-height: 22.4px;
      }
    }

    > li:first-child {
      margin-left: 0;

      &::before {
        display: none;
      }
    }
  }
</style>
